import React from 'react'
import { makeStyles } from '@mui/styles'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import ContentWrapper from './contentWrapper'
import MainWrapper from './mainWrapper'

import Logo from '@assets/images/onboarding/logo_mobile.svg'
import BackArrowIcon from '@assets/images/onboarding/backIcon.svg'

import { prevStep } from '@/redux/ducks/wizard/config'

const PageWrapper = ({
  logo,
  text,
  title,
  heading,
  children,
  disabled,
  hidePrevButton,
  onNextButtonClick,
  onBackButtonClick,
  onAbortButtonClick,
  hideStepper = false,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const { step } = useSelector(state => state.wizard.config)

  const prev = () => {
    if (onBackButtonClick) {
      if (onBackButtonClick()) {
        dispatch(prevStep())
      }
    } else {
      dispatch(prevStep())
    }
  }

  return (
    <ContentWrapper hideStepper={hideStepper}>
      <header className={classes.header}>
        {step > 0 && (
          <button type="button" className={classes.backButton} onClick={prev}>
            <SVGIcon svg={BackArrowIcon} height='16px' width='14px'></SVGIcon>
          </button>
        )}
        <SVGIcon className={classes.logo} height="30px" svg={logo || Logo} />
      </header>
      <MainWrapper
        heading={heading}
        title={title}
        text={text}
        onBackButtonClick={onBackButtonClick}
        disabled={disabled}
        onNextButtonClick={onNextButtonClick}
        onAbortButtonClick={onAbortButtonClick}
        hidePrevButton={hidePrevButton}
      >
        {children}
      </MainWrapper>
    </ContentWrapper>
  )
}

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: 570,
    marginTop: 20,
    position: 'relative',
    '@media (min-width: 800px)': {
      display: 'none',
    },
  },
  logo: {
    height: 30,
  },
  backButton: {
    width: 30,
    height: 30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 'auto',
    border: '0 none',
    background: 'transparent',
    position: 'absolute',
    left: 0,
  },
}))

PageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  heading: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onBackButtonClick: PropTypes.func,
  disabled: PropTypes.bool,
  onNextButtonClick: PropTypes.func.isRequired,
  onAbortButtonClick: PropTypes.func.isRequired,
  hidePrevButton: PropTypes.bool,
  logo: PropTypes.node,
  finishButtonText: PropTypes.string,
}

PageWrapper.defaultProps = {
  onBackButtonClick: null,
  disabled: false,
  hidePrevButton: false,
  logo: null,
}

export default PageWrapper
